const mEditionBillingMyShoppingChangePlanModalPayMethods = {
  mEditionBillingMyShoppingChangePlanModalPayMethods: {
    alerts: {
      changePlan: {
        error: 'Un error ha ocurrido. Verifica los datos y vuelve a intentarlo.'
      }
    },

    buttonCancel: 'Cancelar',
    buttonPrimary: 'Confirmar',

    header: {
      title: 'Medio de pago'
    }
  }
}

export default mEditionBillingMyShoppingChangePlanModalPayMethods
